<template>
  <div class="layout--relative">
    <div
      v-if="emailPlatformShow"
      class="input-group__select-escape"
      @click="hideEmailPlatform"
    ></div>
    <div class="account__form-subsection">
      <h3 class="text-size-md weight--bold layout--margin-bottom-sm">
        Got questions?
      </h3>
    </div>
    <Divider dark />
    <div class="account__form-subsection">
      <ul class="timer-details__faq-list layout--margin-bottom-sm">
        <li class="timer-details__faq-list-item">
          <div class="timer-details__faq-list-icon-wrap">
            <IconDocument class="timer-details__faq-list-icon" />
          </div>
          <div class="timer-details__faq-list-copy">
            <h4 class="text-size-default weight--bold layout--margin-bottom-sm">
              How to paste your timer into an email
            </h4>
            <nav
              aria-label="How to paste timer"
              class="input-group__select-wrap input-group__select-wrap--small input-group__select-wrap--left layout--full-width layout--relative"
            >
              <button
                type="button"
                @click="toggleEmailPlatform"
                class="input-group__select input-group__select--small input-group__select--dark layout--full-width layout--text-left layout--margin-bottom-md"
              >
                Select email platform
              </button>
              <ul
                class="input-group__select-item-list"
                :class="{ 'layout--screen-reader-only': !emailPlatformShow }"
                id="emailPlatform"
              >
                <li
                  class="input-group__select-item"
                  v-for="option in emailPlatformOptions"
                  :key="option.value"
                  @click="hideEmailPlatform"
                >
                  <a :href="option.link" class="input-group__select-link">{{
                    option.value
                  }}</a>
                </li>
              </ul>
            </nav>
            <a
              href="https://motionmail.freshdesk.com/support/solutions/articles/14000025916-will-motionmail-timers-work-with-my-email-marketing-platform-mailchimp-constant-contact-etc-"
              class="link"
              >Is your platform not listed?</a
            >
          </div>
        </li>
        <li
          v-for="question in questions"
          :key="question.value"
          class="timer-details__faq-list-item"
        >
          <div class="timer-details__faq-list-icon-wrap">
            <IconDocument class="timer-details__faq-list-icon" />
          </div>
          <div class="timer-details__faq-list-copy">
            <a :href="question.link" class="link link--plain">
              <h4 class="text-size-default weight--bold">
                {{ question.value }}
              </h4>
            </a>
          </div>
        </li>
      </ul>
      <a
        href="https://motionmail.freshdesk.com/support/solutions/folders/14000016657"
        class="button button--secondary button--somewhat-wide"
        >View all FAQs</a
      >
    </div>
  </div>
</template>

<script>
import Divider from "../../components/Divider";
import IconDocument from "../../assets/icons/iconDocument.svg";

export default {
  name: "faq",
  components: {
    Divider,
    IconDocument,
  },
  data() {
    return {
      emailPlatformShow: false,
      emailPlatformOptions: [
        {
          value: "AWeber",
          link:
            "https://motionmail.freshdesk.com/solution/articles/14000069637-how-do-i-add-a-timer-to-aweber-",
        },
        {
          value: "Campaign Monitor",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000034902-how-do-i-add-a-timer-in-campaign-monitor-",
        },
        {
          value: "Constant Contact",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000064150-how-do-i-add-a-timer-to-constant-contact-",
        },
        {
          value: "ConvertKit",
          link:
            "https://motionmail.freshdesk.com/solution/articles/14000076899-how-do-i-add-a-motionmail-timer-to-convertkit-",
        },
        {
          value: "GetResponse",
          link:
            "https://motionmail.freshdesk.com/solution/articles/14000076907-how-do-i-add-a-countdown-timer-to-getresponse-",
        },
        {
          value: "Gmail",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000060083-how-do-i-add-a-motionmailer-timer-into-gmail-",
        },
        {
          value: "Klaviyo",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000075307-how-do-i-add-a-motionmailer-timer-into-klaviyo-",
        },
        {
          value: "MailChimp",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000064001-how-to-add-countdown-timers-to-mailchimp",
        },
        {
          value: "MailerLite",
          link:
            "https://motionmail.freshdesk.com/solution/articles/14000100192-how-to-add-a-motionmail-timer-to-mailerlite-",
        },
        {
          value: "Outlook",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000056064-can-i-send-an-email-with-your-timer-in-outlook-",
        },
      ],
      questions: [
        {
          value:
            "My emails show the countdown timer embed code instead of the timer itself. What am I doing wrong?",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000003390-my-emails-show-the-countdown-timer-embed-code-instead-of-the-timer-itself-what-am-i-doing-wrong-",
        },
        {
          value: "How do I center the MotionMail timer within my email?",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000022153-how-do-i-center-the-motionmail-timer-",
        },
        {
          value: "Can the MotionMail timers be delivered by HTTPS?",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000045443-can-the-motionmail-timers-be-delivered-by-https-",
        },
        {
          value: "What happens when I run out of credits?",
          link:
            "https://motionmail.freshdesk.com/support/solutions/articles/14000003401-what-happens-when-i-run-out-of-credits-",
        },
      ],
    };
  },
  methods: {
    toggleEmailPlatform: function() {
      this.emailPlatformShow = !this.emailPlatformShow;
    },
    hideEmailPlatform: function() {
      this.emailPlatformShow = false;
    },
  },
};
</script>

<style></style>
